import { render } from "./Card3.vue?vue&type=template&id=98216d5a"
import script from "./Card3.vue?vue&type=script&lang=ts"
export * from "./Card3.vue?vue&type=script&lang=ts"
script.render = render

export default script